module.exports = __webpack_public_path__ + "static/media/3-_DSC7085.879dbf6c.jpg";